/* global angular, moment */

(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name doctor.factory:DoctorHelper
   *
   * @description
   *
   */
  angular
    .module('vcutils.doctor')
    .factory('DoctorHelper', DoctorHelper);
  
  
  DoctorHelper.$inject = ['Doctor', '$uibModal', '$log', 'Rlog'];
  
  function DoctorHelper(Doctor, $uibModal, $log, Rlog) {
    let DoctorHelperBase = {};
    
    DoctorHelperBase.editDoctor = editDoctor;
    DoctorHelperBase.addDoctor = addDoctor;
    DoctorHelperBase.fname = fname;
    
    function addDoctor(success, error) {
      // noinspection JSUnresolvedVariable
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctorform doctor="doctoraCtrl.doctor" parentsave="doctoraCtrl.childsave(doctor)" oncancel="doctoraCtrl.cancel()"></doctornew></div>',
        controllerAs: 'doctoraCtrl',
        controller: ['doctor', function () {
          let vm = this;
          vm.doctor = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(doctor) {
            Doctor.$create(doctor).$then(function (newdoctor) {
              vm.created = true;
              success(newdoctor);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ doctor-helper.addDoctor: ', err);
              Rlog.error('vcutils.doctor', 'doctor-helper.addDoctor', 'Creation of new SV failed: ', {error: err, doctor: doctor});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          doctor: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editDoctor(ldoctor) {
      // noinspection JSUnresolvedVariable
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctorform doctor="doctoreCtrl.doctor" parentsave="doctoreCtrl.childsave(doctor)" oncancel="doctoreCtrl.cancel()"></doctorform></div>',
        controllerAs: 'doctoreCtrl',
        controller: ['doctor', function (sdoctor) {
          let vm = this;
          vm.doctor = sdoctor;
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          
          function childsave(doctor) {
            // vm.doctor = angular.copy(doctor);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in doctor) {
              if (doctor.hasOwnProperty(key)) {
                vm.doctor[key] = doctor[key];
              }
            }
            
            if (vm.doctor.$hasPendingActions()) {
              vm.doctor.$cancel();
              vm.doctor.$save();
              cancel();
            }
            else {
              vm.doctor.$save();
              dialog.close();
            }
          }
          
          
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          doctor: function () {
            return ldoctor;
          }
        },
        size: 'lg'
      });
      return dialog;
    }


    function fname(doc) {
      $log.debug('input doc: ', doc);
      // noinspection JSUnresolvedVariable
      if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.institute) && angular.isString(doc.speciality)) {
        // noinspection JSUnresolvedVariable
        doc.text = doc.firstname + ' ' + doc.lastname + ', ' + doc.institute + ', ' + doc.speciality;
        $log.debug('var 1 doc: ', doc.text);
      }
      // noinspection JSUnresolvedVariable
      else if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.speciality)) {
        // noinspection JSUnresolvedVariable
        doc.text = doc.firstname + ' ' + doc.lastname + ', ' + doc.speciality;
        $log.debug('var 2 doc: ', doc.text);
      }
      // noinspection JSUnresolvedVariable
      else if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.institute)) {
        // noinspection JSUnresolvedVariable
        doc.text = doc.fistname + ', ' + doc.lastname + ', ' + doc.institute;
        $log.debug('var 3 doc: ', doc.text);
      }
      // noinspection JSUnresolvedVariable
      else if (angular.isString(doc.institute) && angular.isString(doc.speciality)) {
        // noinspection JSUnresolvedVariable
        doc.text = doc.institute + ', ' + doc.speciality;
        $log.debug('var 4 doc: ', doc.text);
      }

      return doc.text;
    }



    return DoctorHelperBase;
  }
}());
